import { Prisma } from '@repo/database/src/types';
import type { AgentDeal } from '@repo/database/src/types';
import { IsBoolean, IsOptional } from 'class-validator';

import { PaginationOptionsDto } from '../../pagination-options-types';
import { AdminAgentDealDto } from './admin-agent-deals-query.dto';

export class GetSubAgentDealsDto extends PaginationOptionsDto {
  @IsBoolean()
  @IsOptional()
  includeDeleted?: boolean;

  @IsOptional()
  sorts?: Array<{ field: keyof AgentDeal | string; order: Prisma.SortOrder }>;
}

export interface SubAgentDealsResponseDto {
  items: AdminAgentDealDto[];
  totalCount: number;
  skip: number;
  take: number;
}
